import { Activity, Stethoscope, Apple } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/ui-kit";
import { PageHero, FinalCTA } from "@/components/blocks";
import { images, professionals } from "@/data/site";

const icons = { Osteopata: Activity, Fisioterapista: Stethoscope, Nutrizionista: Apple };

export default function Professionisti() {
  return (
    <>
      <Seo title="Professionisti a Lusciano | Body Evolution 2.0" description="Body Evolution 2.0 integra osteopata, fisioterapista e nutrizionista per percorsi mirati al benessere, alla prevenzione e allo stile di vita." />
      <PageHero label="Professionisti" title="Professionisti per un percorso mirato e su misura" image={images.reception}
        text="Body Evolution 2.0 mette al centro la persona. Per questo, oltre all'allenamento, la palestra integra figure professionali dedicate al benessere, alla prevenzione e al miglioramento dello stile di vita." />

      <section className="bg-ivory py-24 lg:py-32">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
          <Reveal><SectionLabel>Le figure dedicate</SectionLabel></Reveal>
          <div className="mt-12 grid md:grid-cols-3 gap-6">
            {professionals.map((p, i) => {
              const Icon = icons[p.title];
              return (
                <Reveal key={p.title} delay={i * 0.1}>
                  <div className="lift h-full bg-white border border-black/10 rounded-sm p-9 hover:border-gold">
                    <Icon className="text-gold" size={32} strokeWidth={1.4} />
                    <h3 className="mt-6 font-display text-2xl font-medium text-ink-800">{p.title}</h3>
                    <p className="mt-3 text-ink-800/60 leading-relaxed">{p.text}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
          <Reveal delay={0.2}>
            <p className="mt-10 text-sm text-ink-800/50 italic max-w-2xl">
              I nominativi e i dettagli dei professionisti saranno disponibili su appuntamento, nel rispetto della privacy.
            </p>
          </Reveal>
        </div>
      </section>
      <FinalCTA title="Richiedi una consulenza" primary="Richiedi una consulenza"
        text="Raccontaci il tuo obiettivo: ti aiuteremo a individuare il percorso e la figura professionale più adatta alle tue esigenze." />
    </>
  );
}
